import React from 'react'
import { Sensor } from '../Interfaces/Interfaces'
interface Props{
    sensor:Sensor
}
export const EncabezadoTablaSensor = (props:Props) => {
    if(props.sensor.tipo==="temperatura"){
  return (
    <th>'C</th>
  )
}else if(props.sensor.tipo==="acelerometro" || props.sensor.tipo==="giroscopio"){
    return (
        <>
      <th>X</th>
      <th>Y</th>
      <th>Z</th>
      </>
    )
  }
  else if(props.sensor.tipo==="presion"){
    return (
      <th>hPa</th>
      
    )
  }
  
  else if(props.sensor.tipo==="altitud"){
    return (
      <th>MSNM</th>
      
    )
  }
  else if(props.sensor.tipo==='gps'){
    return (
      <>
      <th>Latitud</th>
      <th>Longitud</th>
      </>
    )
  }
return <p>holi</p>
}
